module.exports = __webpack_public_path__ + "img/box_1.ab4d1ead.png";